import { useEffect, useState } from "react";

export const ContactDrawer = ({ open, onClose }) => {
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (!open) setSent(false);
  }, [open]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSent(true);
  };

  if (!open) return null;

  return (
    <div className="contact-layer">
      <button className="contact-scrim" type="button" aria-label="Close contact" onClick={onClose} />
      <aside className="contact-drawer" aria-labelledby="cd-title">
        <button className="cd-close" type="button" onClick={onClose} aria-label="Close">
          ×
        </button>
        {sent ? (
          <div className="cd-done">
            <h2>Nice to meet you.</h2>
            <p>The fastest way to continue is LinkedIn. I’ll reply there.</p>
            <a href="https://www.linkedin.com/in/sukrit-phaopanich/" target="_blank" rel="noopener noreferrer">
              Open LinkedIn
            </a>
          </div>
        ) : (
          <form className="cd-form" onSubmit={handleSubmit}>
            <p className="cd-eyebrow">
              <span className="cd-dot" />
              Currently open
            </p>
            <h2 id="cd-title">Let’s build the next thing</h2>
            <p className="cd-intro">
              LinkedIn is the fastest way to reach me. Or leave a note here. I read every one.
            </p>
            <a
              className="cd-linkedin"
              href="https://www.linkedin.com/in/sukrit-phaopanich/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Message me on LinkedIn
            </a>
            <label className="cd-field">
              Name
              <input name="name" required />
            </label>
            <label className="cd-field">
              Email
              <input type="email" name="email" required />
            </label>
            <label className="cd-field">
              Message
              <textarea name="message" rows={4} required />
            </label>
            <button className="cd-send" type="submit">
              Send it over
            </button>
          </form>
        )}
      </aside>
    </div>
  );
};
